import { createRoute } from "@tanstack/react-router";

import validation from "core/validation";

import { root } from "routes";
import Layout from "theme/ui/Layout";

import Pay from "areas/pay/pages/Pay";


const _root = createRoute({
	getParentRoute: () => root,
	id: "pay-layout",
	component: () => <Layout.Dark />,
	beforeLoad: validation.redirect.unauthenticated
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "pay",
	component: () => <Pay />
});

const pay = _root.addChildren([index]);

export default pay;